

export default class Base {
    constructor() {
        this._events = [];
    }

    // For Events
    
    on(eventName, func) {
        if(typeof(this._events[eventName]) === 'undefined') {
            this._events[eventName] = [];
        }

        this._events[eventName].push( {
            type:'on',
            function: func 
        });
    }

    once(eventName, func) {
        if(typeof(this._events[eventName]) === 'undefined') {
            this._events[eventName] = [];
        }

        this._events[eventName].push( {
            type:'once',
            function: func 
        });
    }

    off(eventName, func) {
        if(typeof(func)=== 'undefined') func = null;

        if(func) {
            const index = this._events[eventName].findIndex(function(event) {
                return event.function == func
              });
              
            this._events[eventName].splice(index, 1);
        } else {
            if(this._events[eventName]) this._events[eventName] = [];
        }
    }

    trigger(eventName, params) {
        if(this._events[eventName]) {
            const deletekeys = [];
            this._events[eventName].forEach((event, index) => {
                if(event.function) {
                    event.function.bind(this)(this, params);

                    if(event.type === 'once') {
                        deletekeys.push(index);
                    }
                }
            });

            if(deletekeys.length > 0) {
                deletekeys.forEach((index) => {
                    delete this._events[eventName][index];
                })
            }
        }
    }
}